import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import ObsadaService from "./ObsadaService";
import TrasyService from "../../trasyConfig/trasy/TrasyService";
import KierowcyService from "../../zasobyConfig/kierowcy/KierowcyService";
import ObsadaListaContainer from "./ObsadaLista/ObsadaListaContainer";
import ObsadaKalendarzContainer from "./ObsadaKalendarz/ObsadaKalendarzContainer";
import PojazdyService from "../../zasobyConfig/pojazdy/PojazdyService";
import ObsadaContainerSelect from "./components/ObsadaContainerSelect";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import moment from 'moment'
import ObsadaZamianaContainer from "./ObsadaZamiana/ObsadaZamianaContainer";
import ObsadaGenerujContainer from "./ObsadaGeneruj/ObsadaGenerujContainer";
import KonfiguracjaService from "../../../administracja/konfiguracja/KonfiguracjaService";
import LSService from "../../../../utilities/localStorageService/LSService";


export default class ObsadaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            obsady: [],
            obsadyBezFiltra: [],
            trasy: [],
            kierowcy: [],
            pojazdy: [],
            activeTab: 1,
            paramsurl: null,
            dataStart: null,
            stopienZapelnienia: false,
            start: null,
            koniec: null,
            czyByloSzukanie: false,
            czyPokazacLoader: false,
            trasa: null,
            kierowca: null,
            kurs: '',
            czyWidokTygodniowyNaKalendarzu: false,
            czyUstawionoPelenWidokKalendarza: false,
            czyDataPoUpdateNaKalendarzu: null,
        };
        this.changeActiveTab = this.changeActiveTab.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
        this.przefiltrujObsade = this.przefiltrujObsade.bind(this)
        this.ukryjObsady = this.ukryjObsady.bind(this)
        this.odswiezObsade = this.odswiezObsade.bind(this)
    }

    componentDidMount() {
        this.pobierzTrasy()
        this.pobierzKierowcow()
        this.pobierzPojazdy()
        this.pobierzDatyOkresowe()

        let dzis = DateAndTimeFormat.formatYYYYMMDD(moment())

        if (Boolean(LSService.pobierzTablicaTrasyObsada())) {
            this.onClickSzukaj(dzis, dzis, LSService.pobierzTablicaTrasyObsada(), null, '', false, false)
        }
        else{
            this.onClickSzukaj(dzis, dzis, null, null, '', false, false)
        }

    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }

    pobierzKierowcow() {
        KierowcyService.getKierowcyAktywni().then(function (response) {
            if (response) {
                let arr = Array.from(response.data, item => {
                    return {
                        ...item,
                        "informacje": item.imie + ' ' + item.nazwisko + ' ' + item.pesel
                    }
                })

                this.setState({kierowcy: arr})
            }
        }.bind(this))
    }

    pobierzPojazdy() {
        PojazdyService.getPojazdy().then(function (response) {
            if (response) {
                let arr = Array.from(response.data.content, item => {
                    return {
                        "idPo": item.idPo,
                        "idRej": item.idRej,
                        "ileMiejsc": item.ileMiejsc,
                        "marka": item.marka,
                        "model": item.model,
                        "nrNadw": item.nrNadw,
                        "nrRej": item.nrRej,
                        "status": item.status,
                        "uwagi": item.uwagi,
                        "informacje": item.marka + ' ' + item.model + ' ' + item.nrRej
                    }
                })

                this.setState({pojazdy: arr})
            }
        }.bind(this))
    }

    pobierzDatyOkresowe() {

        KonfiguracjaService.pobierzWartoscStartRozkladu().then(function (responseStart) {
            KonfiguracjaService.pobierzWartoscKoniecRozkladu().then(function (responseKoniec) {
                let start = responseStart.data;
                let koniec = responseKoniec.data;

                this.setState({
                    start: start,
                    koniec: koniec,
                })
            }.bind(this))
        }.bind(this))

    }


    pobierzObsady(params, stopienZapelnienia) {

        let czyPelenEkran = this.state.czyUstawionoPelenWidokKalendarza

        this.setState({czyUstawionoPelenWidokKalendarza: false})

        if (Boolean(params)) {
            ObsadaService.getObsadaSzukaj(params).then(function (response) {
                if (response) {
                    // jesli jest ustawione aby filtrowalo po zajętości miejsc


                    let remastered_array = Array.from(response.data, item => {

                        let ekipa = "";
                        if (Boolean(item.kod_ek)) {
                            ekipa = item.kod_ek
                        }

                        return {
                            ...item,
                            ekipa_trasa: item.trasa + ekipa
                        }

                    })


                    let poprawnyStopien = false
                    if (stopienZapelnienia) {
                        if (stopienZapelnienia > 0 && stopienZapelnienia < 200) {
                            poprawnyStopien = true
                        }
                    }
                    if (poprawnyStopien) {
                        let arr = remastered_array.filter(o => {
                            if (Boolean(o.il_miejsc_kurs)) {
                                if (o.il_rez + o.il_skas + o.il_sprz >= (o.il_miejsc_kurs * stopienZapelnienia) / 100) return o
                            }
                            else {
                                if (o.il_rez + o.il_skas + o.il_sprz >= (25 * stopienZapelnienia) / 100) return o
                            }
                        })

                        this.setState({
                            obsady: arr,
                            obsadyBezFiltra: remastered_array,
                            czyByloSzukanie: true,
                            czyPokazacLoader: false,
                            czyDataPoUpdateNaKalendarzu: null,
                            czyUstawionoPelenWidokKalendarza: czyPelenEkran
                        })
                    } else {
                        this.setState({
                            obsady: remastered_array,
                            obsadyBezFiltra: remastered_array,
                            czyByloSzukanie: true,
                            czyPokazacLoader: false,
                            czyDataPoUpdateNaKalendarzu: null,
                            czyUstawionoPelenWidokKalendarza: czyPelenEkran
                        })
                    }


                }
            }.bind(this))
        }
    }

    onClickSzukaj(dataOd, dataDo, trasa, kierowca, kurs, stopienZapelnienia, czyPokazywacAnulowaneBisy) {


        let czyWiecejDni = false

        if (moment(dataDo).diff(moment(dataOd), 'days') > 3) {
            czyWiecejDni = true
        }

        let paramsurl = 'szukaj?dataOd=' + dataOd + '&dataDo=' + dataDo

        if (trasa instanceof Array) {
            // mamy wiele tras - tablica zapelniona lub pusta


            if (trasa.length > 0) {

                let ids = ""

                for (let i = 0; i < trasa.length; i++) {
                    if (i === trasa.length-1 || trasa.length === 1) {
                        ids += trasa[i].idTr
                    } else {
                        ids += trasa[i].idTr + ","
                    }
                }

                paramsurl = paramsurl + '&idTr=' + ids
            }

        }
        else {
            //mamy jedną trasę - obiekt lub null
            if (Boolean(trasa)) {
                paramsurl = paramsurl + '&idTr=' + trasa.idTr
            }

        }

        if (Boolean(kierowca)) {
            paramsurl = paramsurl + '&idKi=' + kierowca.idKi
        }

        if (Boolean(kurs)) {
            paramsurl = paramsurl + '&idKu=' + kurs
        }

        if (czyPokazywacAnulowaneBisy) {
            paramsurl = paramsurl + "&czyPokazywacAnulowaneBisy=true"
        }
        else {
            paramsurl = paramsurl + "&czyPokazywacAnulowaneBisy=false"
        }

        this.setState({
            paramsurl: paramsurl,
            dataStart: dataOd,
            stopienZapelnienia: stopienZapelnienia,
            czyByloSzukanie: false,
            czyPokazacLoader: false,
            trasa: trasa,
            kierowca: kierowca,
            kurs: kurs,
            czyWidokTygodniowyNaKalendarzu: czyWiecejDni
        })

        this.pobierzObsady(paramsurl, stopienZapelnienia)
    }

    przefiltrujObsade(stopienZapelnienia) {
        let poprawny = false;
        if (Boolean(stopienZapelnienia)) {
            if (stopienZapelnienia > 0 && stopienZapelnienia < 200) {
                poprawny = true
            }
        }
        if (poprawny) {
            let arr = this.state.obsadyBezFiltra.filter(o => {
                if (Boolean(o.il_miejsc_kurs)) {
                    if (o.il_rez + o.il_skas + o.il_sprz >= (o.il_miejsc_kurs * stopienZapelnienia) / 100) return o
                }
                else {
                    if (o.il_rez + o.il_skas + o.il_sprz >= (25 * stopienZapelnienia) / 100) return o
                }
            })
            this.setState({obsady: arr, stopienZapelnienia: stopienZapelnienia})

        }
        else {
            this.setState({stopienZapelnienia: false, obsady: this.state.obsadyBezFiltra})
        }
    }


    odswiezObsade(obj, action, objRest) {

        console.log(obj)
        console.log(objRest)

        // obj - zwracany obiekt z response.data
        // action - akcja
        // objRest - obiekt, ktory jest dawany do resta


        if (Boolean(obj) && action !== 'odswiezenieTimer') {

            this.setState({
                obsady: [],
                //    czyByloSzukanie: false,
                //    czyPokazacLoader: false,
            })

            let array = this.state.obsadyBezFiltra

            if (action === 'zablokuj') {
                array.find(o => o.id_ob === obj.id_ob)['zablokowane'] = 1
            }
            else if (action === 'odblokuj') {
                array.find(o => o.id_ob === obj.id_ob)['zablokowane'] = 0
            }
            else if (action === 'odwolaj' || action === 'odwolanie') {
                array.find(o => o.id_ob === obj.id_ob)['zablokowane'] = 2
            }
            else if (action === "odwolajBis") {
                array.find(o => o.id_ob === obj.id_ob)['czy_odw_obsada'] = true
            }
            else if (action === "przywrocBis") {
                array.find(o => o.id_ob === obj.id_ob)['czy_odw_obsada'] = false
            }
            else if (action === 'dodanie') {
                // alert('dodanie nowej obsady')

                let newobj = {
                    "trasa": obj.trasa,
                    "data": obj.data,
                    "godz_1p": objRest.godz_1p,
                    "naz_po": obj.nazPo,
                    "naz_ki": obj.nazKi,
                    "imie_naz": obj.imieNaz,
                    "id_ob": obj.idOb,
                    "id_ku": obj.idKu,
                    "id_tr": obj.idTr,
                    "id_po": obj.idPo,
                    "id_ki": obj.idKi,
                    "kod_ek": null,
                    "kolor": null,
                    "zablokowane": obj.zablokowane,
                    "il_rez": 0,
                    "il_sprz": 0,
                    "il_skas": 0,
                    "il_miejsc_poj": obj.ilMiejscPoj,
                    "il_miejsc_kurs": obj.ilMiejscKurs,
                    "id_pr_od": obj.idPrOd,
                    "id_pr_do": obj.idPrDo,
                    "naz_pr_od": obj.nazPrOd,
                    "naz_pr_do": obj.nazPrDo,
                    "czy_cala_tr": obj.czyCalaTr,
                    "imie_naz_kier_oryg": obj.imieNaz,
                    "id_ki_oryg": obj.idKi,
                    "stawka": objRest.stawka,
                    "powod_zam": '',
                    "uwagi": '',
                    "status_obsady": 1,
                    "typ_plat": objRest.typPlat,
                    "stat_kursu": 0,
                    "czy_bis": 0,
                    "start_kursu": null,
                    "koniec_kursu": null,
                    "ekipa_trasa": obj.trasa + " " + obj.kodEk,
                    "obsada_wpisal": obj.obsadaWpisal,
                    "obsada_zmienil": obj.obsadaZmienil,
                    "kurs_wpisal": obj.kursWpisal,
                    "kurs_zmienil": obj.kursZmienil,
                    "bis_dodal_kto": obj.bisDodalKto,
                    "ile_skas_kierowca": null,
                    "ile_sprz_kierowca": null,
                    ile_odb_mies_popr:obj.ileOdbMiesPopr,
                    ile_odb_mies_niepopr:obj.ileOdbMiesNiepopr,
                }
                array.unshift(newobj)

            }
            else if (action === 'duplikacja') {
                //  alert('zduplikowanie obsady')

                let doubleobj = {
                    "trasa": obj.trasa,
                    "data": obj.data,
                    "godz_1p": parseFloat(obj.godz_1p.replace(':',".")),
                    "naz_po": obj.nazPo,
                    "naz_ki": obj.nazKi,
                    "imie_naz": obj.imieNaz,
                    "id_ob": obj.idOb,
                    "id_ku": obj.idKu,
                    "id_tr": obj.idTr,
                    "id_po": obj.idPo,
                    "id_ki": obj.idKi,
                    "kod_ek": null,
                    "kolor": null,
                    "zablokowane": obj.zablokowane,
                    "il_rez": obj.ilRez,
                    "il_sprz": obj.ilSprz,
                    "il_skas": obj.ilSkas,
                    "il_miejsc_poj": obj.ilMiejscPoj,
                    "il_miejsc_kurs": obj.ilMiejscKurs,
                    "id_pr_od": obj.idPrOd,
                    "id_pr_do": obj.idPrDo,
                    "naz_pr_od": obj.nazPrOd,
                    "naz_pr_do": obj.nazPrDo,
                    "czy_cala_tr": obj.czyCalaTr,
                    "imie_naz_kier_oryg": obj.imieNaz,
                    "nr_tel_ebus": obj.nr_tel_ebus,
                    "id_ki_oryg": obj.idKi,
                    "stawka": objRest.stawka,
                    "powod_zam": '',
                    "uwagi": '',
                    "status_obsady": 1,
                    "typ_plat": objRest.typPlat,
                    "stat_kursu": obj.statKursu,
                    "czy_bis": 1,
                    "start_kursu": null,
                    "koniec_kursu": null,
                    "ekipa_trasa": obj.trasa + " " + obj.kodEk,
                    "obsada_wpisal": obj.obsadaWpisal,
                    "obsada_zmienil": obj.obsadaZmienil,
                    "kurs_wpisal": obj.kursWpisal,
                    "kurs_zmienil": obj.kursZmienil,
                    "bis_dodal_kto": obj.bisDodalKto,
                    "ile_skas_kierowca": null,
                    "ile_sprz_kierowca": null,
                    ile_odb_mies_popr:obj.ileOdbMiesPopr,
                    ile_odb_mies_niepopr:obj.ileOdbMiesNiepopr,
                }

                let index = array.findIndex(i => i.id_ku === obj.idKu)
                array[index].il_miejsc_kurs = obj.ilMiejscKurs
                array.splice(index + 1, 0, doubleobj)
            }
            else if (action === 'zamiana') {
                //  alert('zamiana kierowcy i lub pojazdu w obsadzie')


                let changeobj = {
                    "trasa": obj.trasa,
                    "data": obj.data,
                    "godz_1p": parseFloat(obj.godz_1p.replace(':',".")),
                    "naz_po": obj.nazPo,
                    "naz_ki": obj.nazKi,
                    "imie_naz": obj.imieNaz,
                    "id_ob": obj.idOb,
                    "id_ku": obj.idKu,
                    "id_tr": obj.idTr,
                    "id_po": obj.idPo,
                    "id_ki": obj.idKi,
                    "kod_ek": obj.kodEk,
                    "kolor": obj.kolor,
                    "zablokowane": obj.zablokowane,
                    "il_rez": obj.ilRez,
                    "il_sprz": obj.ilSprz,
                    "il_skas": obj.ilSkas,
                    "il_miejsc_poj": obj.ilMiejscPoj,
                    "il_miejsc_kurs": obj.ilMiejscKurs,
                    "id_pr_od": obj.idPrOd,
                    "id_pr_do": obj.idPrDo,
                    "naz_pr_od": obj.nazPrOd,
                    "naz_pr_do": obj.nazPrDo,
                    "czy_cala_tr": obj.czyCalaTr,
                    "imie_naz_kier_oryg": obj.imieNazKierOryg,
                    "nr_tel_ebus": obj.nr_tel_ebus,
                    "id_ki_oryg": obj.idKiOryg,
                    "stawka": objRest.stawka,
                    "powod_zam": objRest.powodZam,
                    "uwagi": objRest.uwagi,
                    "status_obsady": 1,
                    "typ_plat": objRest.typPlat,
                    "stat_kursu": obj.statKursu,
                    "czy_bis": objRest.czyBis,
                    "start_kursu": null,
                    "koniec_kursu": null,
                    "ekipa_trasa": obj.trasa + " " + obj.kodEk,
                    "obsada_wpisal": obj.obsadaWpisal,
                    "obsada_zmienil": obj.obsadaZmienil,
                    "kurs_wpisal": obj.kursWpisal,
                    "kurs_zmienil": obj.kursZmienil,
                    "bis_dodal_kto": obj.bisDodalKto,
                    "ile_skas_kierowca": obj.ileSkasKierowca,
                    "ile_sprz_kierowca": obj.ileSprzKierowca,
                    ile_odb_mies_popr:obj.ileOdbMiesPopr,
                    ile_odb_mies_niepopr:obj.ileOdbMiesNiepopr,
                }

                let index = array.findIndex(i => i.id_ku === obj.idKu)
                array.splice(index, 1, changeobj)


            }
            else if (action === 'edycja') {
                // alert('akcja edycji rekordu')
            }

            this.setState({
                czyDataPoUpdateNaKalendarzu: obj.data
            })


            this.setState({
                obsadyBezFiltra: array,
                obsady: array,
                //  czyByloSzukanie: true,
                //  czyPokazacLoader: false
            })
        } else {

            if (Boolean(this.state.paramsurl)) {
                this.setState({
                    obsady: [],
                    czyByloSzukanie: false,
                    czyPokazacLoader: false,
                })
                this.pobierzObsady(this.state.paramsurl, this.state.stopienZapelnienia)
            }
        }
    }

    ukryjObsady() {
        this.setState({obsady: [], czyByloSzukanie: false})
    }

    renderContent() {
        if (this.state.activeTab === 1) {
            if (this.state.obsady.length == 0 && !this.state.czyByloSzukanie) {
                return <div style={{color: 'gray', fontStyle: 'italic'}}>Kliknij przycisk Szukaj aby wyświetlić dane</div>
            }
            else if (this.state.czyPokazacLoader) {
                return <div>
                    <div id={'smallLoader'}>
                        <i className={'fa fa-circle-o-notch fa-spin'}></i>
                        <div>Trwa ładowanie danych...</div>
                    </div>
                </div>
            }
            else
                return <ObsadaListaContainer obsady={this.state.obsady} trasy={this.state.trasy} kierowcy={this.state.kierowcy}
                                             pojazdy={this.state.pojazdy} handlePobierzObsade={this.odswiezObsade}
                                             history={this.props.history}
                />
        }
        else if (this.state.activeTab === 2) {
            if (this.state.obsady.length == 0 && !this.state.czyByloSzukanie) {
                return <div style={{color: 'gray', fontStyle: 'italic'}}>Kliknij przycisk Szukaj aby wyświetlić dane</div>
            }
            else
                return <ObsadaKalendarzContainer obsady={this.state.obsady} trasy={this.state.trasy} kierowcy={this.state.kierowcy}
                                                 pojazdy={this.state.pojazdy} handlePobierzObsade={this.odswiezObsade}
                                                 trasa={this.state.trasa}
                                                 kierowca={this.state.kierowca}
                                                 dataStart={this.state.dataStart}
                                                 history={this.props.history}
                                                 czyWidokTygodniowyNaKalendarzu={this.state.czyWidokTygodniowyNaKalendarzu}
                                                 czyUstawionoPelenWidokKalendarza={this.state.czyUstawionoPelenWidokKalendarza}
                                                 handleClickUstawieniePelnegoEkranu={(val) => {
                                                     this.setState({czyUstawionoPelenWidokKalendarza: val})
                                                 }}
                                                 czyDataPoUpdateNaKalendarzu={this.state.czyDataPoUpdateNaKalendarzu}
                />
        } else if (this.state.activeTab === 3) {
            return <ObsadaZamianaContainer handlePobierzObsade={this.odswiezObsade}
                                           kierowcy={this.state.kierowcy}
                                           pojazdy={this.state.pojazdy}
            />
        } else {
            return <ObsadaGenerujContainer trasy={this.state.trasy} start={this.state.start} koniec={this.state.koniec}/>
        }
    }

    changeActiveTab(eventKey) {
        this.setState({activeTab: eventKey})
    }


    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ObsadaContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/rozklad-jazdy',
                                    text: 'Rozkład jazdy'
                                }, {addressUrl: '/konfiguracja/rozklad-jazdy/obsada', text: 'Obsada'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <ObsadaContainerSelect trasy={this.state.trasy} kierowcy={this.state.kierowcy}
                                                   handleClickSzukaj={this.onClickSzukaj}
                                                   handleUkryjObsady={this.ukryjObsady}
                                                   handleOdswiezObsade={this.odswiezObsade}
                                                   handleChangeZapelnienie={this.przefiltrujObsade}
                                                   czyUstawionoPelenWidokKalendarza={this.state.czyUstawionoPelenWidokKalendarza}

                            />
                            <div style={{height: '30px', clear: 'both'}}></div>
                        </Col>
                        <Col sm={12}>
                            <Tabs defaultActiveKey={1} id="obsada-tab" onSelect={this.changeActiveTab}>
                                <Tab eventKey={1} title="Widok listy">
                                </Tab>
                                <Tab eventKey={2} title="Widok kalendarza">
                                </Tab>
                                <Tab eventKey={3} title="Zamiana">
                                </Tab>
                                <Tab eventKey={4} title="Generuj obsadę">
                                </Tab>
                            </Tabs>
                        </Col>
                        <Col sm={12}>
                            <div style={{marginTop: '15px'}}>
                                {this.renderContent()}
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaContainer.js